module.exports = __webpack_public_path__ + "img/what-to-expect-hero@2x.0cac08f1.png";